/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import 'alpinejs'
window.moment = require('moment');
window._ = require('lodash');

require('../bootstrap');
require('../plugins');
require('select2');
require('jquery-validation');
require("jscrollpane/script/jquery.mousewheel.js");
require("jscrollpane/script/jquery.jscrollpane.min.js");

require('./thienthao');
require('bootstrap-star-rating/js/star-rating');
require('../plugins/numberscroller');
require('bootstrap-star-rating/themes/krajee-fas/theme');
window.aos = require('aos');
aos.init();

